import React,{useState, useEffect} from 'react';
import {Link, useNavigate} from "react-router-dom";
import { FormControl, TextField, Typography, Box, Button } from '@mui/material';
import logo from '../../Components/assets/images/logo.png';
import {toast } from 'react-toastify';
import { BaseUrl ,Forgot_Password,Signin } from '../../services/Url';


function ForgotPassword(props){
	const navigate = useNavigate();
	const auth = localStorage.getItem('token');
	const [email, setEmail] = useState("");
	const [status, setStatus] = useState(false)

	const submit = async (e) => {
		fetch(`${BaseUrl + Forgot_Password}`,{
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ 
				"email" : email
			 })
		})
		.then(async response => {
			const data = await response.json();
			if (response?.status === 200) {
				setStatus(true)
				toast.success(data.response);
			}
			else{
				toast.error(data.response);
			}
		})
		.catch(error => {
			toast.error(error);
		});
	}	
	
	return (
		<Box className='lgn_mdl_wpr'>
		<form
			onSubmit={submit}
			className="lgn_mdl"
			style={{

				width: " 500px ",
				margin: '0 auto',
				padding: "30px"
			}}
		>
			<Box>
			<div className='logo'>
				<img src={logo} alt='popular' loading='lazy'  />
			</div>
			{!status ? 
			<>
			<Typography variant='h4' marginBottom={4}>
			 Verify Email
			</Typography>
			<Box display='flex' width='100%' flexDirection='column' gap={2} marginBottom={4}>
				<FormControl sx={{mb: 1}}>
                    <TextField	type='email' label='Email' onChange={(e) => setEmail(e.target.value)}/>
				</FormControl>
			</Box>
			<Button  onClick={email ? submit : ''}  className='fluid_btn'>Submit</Button>
			</>: 
			<Typography variant='h6' marginBottom={4} align='center'>
				Email Sent Successfully to your Account Please check and Reset Your Password	
			</Typography>
			}
			</Box>
		</form>
		</Box>
	);
}

export default ForgotPassword;